<template>
  <div v-if="visible" class="ai-loading-overlay">
    <div class="ai-loading-content">
      <div class="ai-loading-spinner">
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
      </div>
      <div class="ai-loading-text">
        <div class="loading-title">{{ displayTitle }}</div>
        <div class="loading-dots">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AiLoading',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '正在加载...'
    },
    // 外部传入的预计时间文本（含"预计时间：XX秒..."），优先使用，避免主副屏随机值不一致
    yujishijian: {
      type: String,
      default: ''
    }
  },
  computed: {
    displayTitle () {
      if (this.yujishijian) return this.title + this.yujishijian
      if (this.title.includes('构建专属资产配置方案'))
        return this.title + '，预计约35秒~ 请稍后...'
      else if (this.title.includes('压力测试完成'))
        return this.title + '，预计时间：1分钟~ 请稍等...'
      else return this.title + `，预计时间：${Math.floor(Math.random() * 31 + 30)}秒...`
    }
  },

}
</script>

<style scoped>
.ai-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999999;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.ai-loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
}

.ai-loading-spinner {
  position: relative;
  width: 120px;
  height: 120px;
}

.spinner-ring {
  position: absolute;
  border-radius: 50%;
  border: 3px solid transparent;
  animation: spin 1.5s linear infinite;
}

.spinner-ring:nth-child(1) {
  width: 120px;
  height: 120px;
  border-top-color: #3b82f6;
  border-right-color: #3b82f6;
  animation-delay: 0s;
}

.spinner-ring:nth-child(2) {
  width: 90px;
  height: 90px;
  top: 15px;
  left: 15px;
  border-top-color: #8b5cf6;
  border-right-color: #8b5cf6;
  animation-delay: 0.2s;
}

.spinner-ring:nth-child(3) {
  width: 60px;
  height: 60px;
  top: 30px;
  left: 30px;
  border-top-color: #ec4899;
  border-right-color: #ec4899;
  animation-delay: 0.4s;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.ai-loading-text {
  text-align: center;
}

.loading-title {
  font-size: 24px;
  font-weight: 600;
  color: #3b82f6;
  margin-bottom: 20px;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.6;
  }
}

.loading-dots {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-top: 10px;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #3b82f6;
  animation: bounce 1.4s ease-in-out infinite;
}

.dot:nth-child(1) {
  animation-delay: 0s;
}

.dot:nth-child(2) {
  animation-delay: 0.2s;
}

.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes bounce {

  0%,
  80%,
  100% {
    transform: scale(0);
  }

  40% {
    transform: scale(1);
  }
}
</style>